export default __webpack_public_path__ + "static/Data-comparing-ba12e8af67a9f0b158d0fc1c7f9a8d12.png";